module.exports = __webpack_public_path__ + "img/715.2831646d.png";